import {Descriptions, Tag} from 'antd';
import {Level, Package, Test, StudentsConnection} from '../../../graphql/API';
import {LevelUI} from '../../Level/LevelTypes';

interface EnrollmentSummaryProps {
  formValues: any;
  students?: StudentsConnection;
  packages: Package[];
  levels: LevelUI[];
  tests: Test[];
  curriculums: any[];
  showCustomPrice: boolean;
  /** Pass directly in Edit mode (no students list needed) */
  studentName?: string;
}

export const EnrollmentSummary = ({
  formValues,
  students,
  packages,
  levels,
  tests,
  curriculums,
  showCustomPrice,
  studentName,
}: EnrollmentSummaryProps) => {
  // Resolve student name — from prop (Edit) or from list (Create)
  const resolvedStudentName =
    studentName ??
    students?.items?.find(
      s => ((s as any)._id || s.id) === formValues?.studentId,
    )?.name ??
    '-';

  const pkg = packages?.find(
    p => ((p as any)._id || p.id) === formValues?.packageId,
  );
  const level = levels?.find(
    l => ((l as any)._id || l.id) === formValues?.levelId,
  );
  const test = tests?.find(
    t => ((t as any)._id || t.id) === formValues?.testId,
  );
  const curriculum = curriculums?.find(c => c.id === formValues?.curriculumId);

  const pkgName = pkg
    ? typeof pkg.name_i18n === 'string'
      ? JSON.parse(pkg.name_i18n)['en']
      : (pkg.name_i18n as any)?.en
    : '-';

  const startDateDisplay = formValues?.startDate
    ? (formValues.startDate.format?.('YYYY-MM-DD') ?? formValues.startDate)
    : '-';

  return (
    <Descriptions
      title="Review Before Submitting"
      bordered
      size="small"
      column={2}
      style={{marginTop: 8}}>
      <Descriptions.Item label="Student">
        {resolvedStudentName}
      </Descriptions.Item>
      <Descriptions.Item label="Package">{pkgName || '-'}</Descriptions.Item>
      <Descriptions.Item label="Level">{level?.name || '-'}</Descriptions.Item>
      <Descriptions.Item label="Test">{test?.name || '-'}</Descriptions.Item>
      <Descriptions.Item label="Curriculum">
        {curriculum?.name || '-'}
      </Descriptions.Item>
      <Descriptions.Item label="Start Date">
        {startDateDisplay}
      </Descriptions.Item>
      <Descriptions.Item label="Currency">
        <Tag color="blue">{formValues?.currency || 'EGP'}</Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Price">
        {showCustomPrice && formValues?.finalPrice !== undefined ? (
          `${formValues.finalPrice} ${formValues?.currency || 'EGP'}`
        ) : (
          <Tag color="green">Auto from package</Tag>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Payment Method">
        <Tag>{formValues?.paymentMethod || 'stripe'}</Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Placement Status">
        <Tag
          color={
            formValues?.placementStatus === 'DONE'
              ? 'success'
              : formValues?.placementStatus === 'DOING'
                ? 'warning'
                : 'error'
          }>
          {formValues?.placementStatus || 'TODO'}
        </Tag>
      </Descriptions.Item>
    </Descriptions>
  );
};
